import request from "@/utils/request";
import type { RequestErrorHandler } from "@/types/request";

export interface LoginPayload {
  username: string;
  password: string;
  captchaKey?: string;
  captchaCode?: string;
}

export interface LoginVerifyCodeApplyPayload {
  account: string;
  accountType: "account" | "email" | "phone";
}

export interface LoginVerifyCodeCheckPayload {
  account: string;
  accountType: "account" | "email" | "phone";
  verifyCode: string;
}

export interface ChangePasswordPayload {
  userId: string;
  password: string;
  newPassword: string;
  trueNewPassword: string;
}

export interface PublicChangePasswordPayload {
  username: string;
  password: string;
  newPassword: string;
  trueNewPassword: string;
}

export interface ResetPasswordPayload {
  userId: string;
  passwordValidDays?: number;
  maxCharType?: number;
}

export interface ResetPasswordResult {
  username?: string;
  password?: string;
}

export interface PasswordChangeResult {
  code?: number | string;
  status?: number;
  data?: {
    success?: boolean;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

export interface UserListParams {
  pageSize: number;
  curPage: number;
  roles?: string[];
  userIds?: string[];
  mergeAuthSchools?: boolean;
  authSchoolIds?: string[];
  keywords?: string;
}

export interface UserSchoolAuthPayload {
  userSchoolAuthId?: string;
  userId?: string;
  schoolId: string;
  [key: string]: unknown;
}

export const login = async (
  data: LoginPayload,
  onError?: RequestErrorHandler
) =>
  await request({
    // 登录
    url: "/login",
    method: "POST",
    headers: {
      jwtusername: data.username,
      jwtpassword: data.password,
      "Content-Type": "application/json",
    },
    data,
    onError,
  });

export const loginVerifyCodeApply = (
  data: LoginVerifyCodeApplyPayload,
  onError?: RequestErrorHandler
) =>
  request({
    url: "/v1/loginVerifyCodeApply",
    method: "POST",
    data,
    onError,
  });

export const loginVerifyCodeCheck = (
  data: LoginVerifyCodeCheckPayload,
  onError?: RequestErrorHandler
) =>
  request({
    url: "/v1/checkLoginVerifyCode",
    method: "POST",
    data,
    onError,
  });

export const getUserInfo = () =>
  request({
    // 获取用户信息
    url: "/getUserInfo",
    method: "POST",
  });
export const setUserInfo = (data: Record<string, unknown>) =>
  request({
    // 获取用户信息
    url: "/setUserInfo",
    method: "POST",
    data,
  });

export const logout = () =>
  request({
    // 登出
    url: "/public/logout",
    method: "GET",
  });

export const publicChangePassword = (data: PublicChangePasswordPayload) =>
  request({
    // 修改密码
    url: "/public/changePassword",
    method: "POST",
    data,
  });

export const changePassword = (data: ChangePasswordPayload) =>
  request({
    // 修改密码
    url: "/changePassword",
    method: "POST",
    data,
  });

export const upgradePassword = (data: {}) =>
  request({
    // 升级密码
    url: "/upgradePassword",
    method: "POST",
    data,
  });

export const resetPassword = (data: ResetPasswordPayload) =>
  request({
    // 重置密码
    url: "/resetPassword",
    method: "POST",
    data,
  });

export const getUserList = (params: UserListParams) =>
  request({
    // 获取用户列表
    url: "/userList",
    method: "GET",
    params,
  });

export const delUser = (userId: string) =>
  request({
    // 删除用户
    url: `/user/${userId}`,
    method: "DELETE",
  });

export const Adduser = (data: Record<string, unknown>) =>
  request({
    // 添加用户
    url: "/user",
    method: "POST",
    data,
  });

export const getUser = (userId: string) =>
  request({
    // 查询用户
    url: `/user/${userId}`,
    method: "GET",
  });

/**
 * 获取学校授权列表
 * @param data
 * @returns
 */
export const getUserSchoolAuthList = (params: {
  pageSize: number;
  curPage: number;
  userId?: string;
  userIds?: string[];
  schoolId?: string;
}) =>
  request({
    url: "/v1/UserSchoolAuthList",
    method: "GET",
    params,
  });

/**
 * 获取学校授权
 * @param userSchoolAuthId
 * @returns
 */
export const getUserSchoolAuth = (userSchoolAuthId: string) =>
  request({
    url: `/v1/UserSchoolAuth/${userSchoolAuthId}`,
    method: "GET",
  });
/**
 * 删除学校授权
 * @param userSchoolAuthId
 * @returns
 */
export const delUserSchoolAuth = (userSchoolAuthId: string) =>
  request({
    url: `/v1/UserSchoolAuth/${userSchoolAuthId}`,
    method: "DELETE",
  });

/**
 * 保存学校授权
 * @param data
 * @returns
 */
export const postUserSchoolAuth = (data: UserSchoolAuthPayload) =>
  request({
    url: "/v1/UserSchoolAuth",
    method: "POST",
    data,
  });
